import React, { Component } from 'react'
import HeaderUserInfoView from '../component/HeaderUserInfoView'
import { authorization } from '../../../../Module/Auth/Auth'
import { getRoleNameFromRoleConst } from '../../../../Utils/Misc'

export default class HeaderUserInfo extends Component {
  state = {
    userName: 'Oppizi',
    userRole: '',
    dropDownOpened: false,
  }

  componentDidMount() {
    const { firstName, lastName, role } = authorization.getUser()
    this.setState({
      userName: `${firstName} ${lastName}`,
      userRole: getRoleNameFromRoleConst(role),
    })
  }

  toggleDropDown = () => {
    this.setState({ dropDownOpened: !this.state.dropDownOpened })
  }

  render() {
    const { userName, userRole, dropDownOpened } = this.state
    return (
      <HeaderUserInfoView
        name={userName}
        role={userRole}
        dropDownOpened={dropDownOpened}
        toggleDropDown={this.toggleDropDown}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderUserInfo/container/HeaderUserInfo.js